import {
  BrowserRouter as Router,
  Routes,
  Route} from "react-router-dom";
import HomeScreen from "./pages/HomeScreen";

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<HomeScreen />} />
      </Routes>
    </Router>
  );
}

export default App;
